import React from 'react'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import { useMerchant } from '@contexts/admin/MerchantContext'
import OrderShow from '@shared/orders/OrderShow'
import { useLoaderData } from 'react-router-dom'

import { adminApiFetch } from '@services/admin/apiService'
import { orderService } from '@services/admin/orderService'
import { shipmentService } from '@services/admin/shipmentService'
import { thirdPartyApiLogService } from '@services/admin/thirdPartyApiLogService'
import { webhookDeliveryService } from '@services/admin/webhookDeliveryService'
import { partnerApiLogService } from '@services/admin/partnerApiLogService'
import { contactAddressService } from '@services/admin/contactAddressService'

import adminCable from '@/lib/adminCable'

const AdminOrderShow: React.FC = () => {
  const order = useLoaderData()
  // useAdminNotification 是 .jsx，JSDoc `@returns {Object}` 讓 TS 把 return 看成空 Object；
  // 這裡 cast 成實際 runtime shape，不是 JSX 元件 cast。
  const { addJob } = useAdminNotification() as { addJob: (...args: any[]) => void }
  const { currentMerchant } = useMerchant()

  return (
    <OrderShow
      role="admin"
      order={order}
      orderService={orderService}
      shipmentService={shipmentService}
      thirdPartyApiLogService={thirdPartyApiLogService}
      webhookDeliveryService={webhookDeliveryService}
      partnerApiLogService={partnerApiLogService}
      cableManager={adminCable}
      addJob={addJob}
      merchantId={currentMerchant?.id}
      contactAddressService={contactAddressService}
    />
  )
}

export default AdminOrderShow
